import progressBar from '../../../components/progressBar/index.vue'
import {  commonUrl,sendLog } from "../../../util/util"

export default {
    components: {
        progressBar
    },
    data() {
        return {
            portrait:require('../../../images/common/default-head.png'),
            lockInfo: {},
            memberInfo: {},
            companyInfo:{},
            taskInfo: {},
            memberDayInfo: {},
            showBar: false,
            privilegeList: [],
            growthValueBar:{},
            growthValueBar1:{},
        }
    },
    computed: {
        
    },
    created() {
        // var aaa=1
        // this.growthValueBar={
        //     "value":50,//百分比
        //     "growthValue":50,//成长值
        //     "mCBarTips":"mCBarTips"+aaa,
        //     "leftImg":"common/mC-star1.png",
        //     "rightImg":"common/mC-star2.png",
        //     "mCBgBar":"mCBgBar1",
        //     "mCBar":"mCBar1"
        // }
        this.growthValueBar1={
            "value":80,//百分比
            "growthValue":"超过80%",//成长值
            "mCBarTips":"mCBarTipsGreen",
            "leftImg":"common/mC-growth-left.png",
            "rightImg":"common/mC-growth-right.png",
            "mCBgBar":"mCBgBarGreen",
            "mCBar":"mCBarGreen"
        }
        var that=this;
        axios.post('/member/index').then(function (res) {
            console.log(res)
            debugger
            that.test=res.data.data;
            that.lockInfo=res.data.data.lockInfo;
            that.memberInfo=res.data.data.memberInfo;
            that.companyInfo=res.data.data.companyInfo;
            that.taskInfo=res.data.data.taskInfo;
            that.memberDayInfo=res.data.data.memberDayInfo;
            that.portrait=res.data.data.portrait?res.data.data.portrait:that.portrait;
            for (var i = 0; i < that.companyInfo.privilegeList.length; i++) {
                var obj={"className":"mC-power-img"+(i+1),"privilegeName":that.companyInfo.privilegeList[i].privilegeName}
                that.privilegeList.push(obj);
            }
            that.showBar=true;
            // that.growthValueBar={
            //     "value":(that.memberInfo.score-that.memberInfo.curLevelScore)/(that.memberInfo.nextLevelScore-that.memberInfo.curLevelScore)*100,//百分比
            //     "growthValue":that.memberInfo.score,//成长值
            //     "mCBarTips":"mCBarTips"+that.memberInfo.curLevelId,
            //     "leftImg":"common/mC-star"+that.memberInfo.curLevelId+".png",
            //     "rightImg":"common/mC-star"+(that.memberInfo.curLevelId+1)+".png",
            //     "mCBgBar":"mCBgBar"+that.memberInfo.curLevelId,
            //     "mCBar":"mCBar"+that.memberInfo.curLevelId,
            // }
        });
    },
    mounted() {
        sendLog("1093");
    },
    methods: {
        // 去在线客服
        goOnLineService(){
            this.$router.push({
                path: '/accountEquity/serveOnline',
                name: 'serveOnline',
            })
        },
        // 去会员特权页面
        goMemberPower(){
            sendLog("1094");
            this.$router.push({
                path: '/memberCenter/memberPower',
                name: 'memberPower',
            })
        },
        
        // 去我的礼品详情页
        goGiftDetail(num){
            switch(num){
                case 0:// 去我的礼品券页面
                    sendLog("1095");
                    this.$router.push({
                        path: '/memberCenter/myGiftTicket',
                        name: 'myGiftTicket',
                    })
                break;
                case 1:// 去在线客服页面
                    sendLog("1097");
                    this.$router.push({
                        path: '/accountEquity/serveOnline',
                        name: 'serveOnline',
                    })
                break;
                case 2:// 去生日福利页面
                    sendLog("1098");
                    this.$router.push({
                        path: '/memberCenter/birthdayWelfare',
                        name: 'birthdayWelfare',
                    })
                break;
                case 3:// 去选材定价培训页面
                    sendLog("1099");
                    this.$router.push({
                        path: '/memberCenter/priceTrain',
                        name: 'priceTrain',
                    })
                break;
                case 4:// 去产品优先体验权页面
                    sendLog("1099");
                    this.$router.push({
                        path: '/memberCenter/productFirstUse',
                        name: 'productFirstUse',
                    })
                break;
                case 5:// 去年度纪念礼盒页面
                    this.$router.push({
                        path: '/memberCenter/annualGift',
                        name: 'annualGift',
                    })
                break;
            }
            
        },
        // 去会员成长规则页面
        goMemberGrowthRule(){
            this.$router.push({
                path: '/memberCenter/memberGrowthRule',
                name: 'memberGrowthRule',
            })
        },
        // 去会员等级页面
        goMemberGrade(){
            this.$router.push({
                path: '/memberCenter/memberGrade',
                name: 'memberGrade',
            })
        },
        // 去会员任务页面
        goMemberTask(){
            this.$router.push({
                path: '/memberTask/memberTaskIndex',
                name: 'memberTaskIndex',
            })
        },
        // 去会员日页面
        goMemberDay(){
            sendLog("1100");
            this.$router.push({
                path: '/memberDay/memberDayIndex',
                name: 'memberDayIndex',
            })
        },
    }
}